module.exports = __webpack_public_path__ + "img/sales.023649ed.png";